// extracted by mini-css-extract-plugin
export var change = "_40-1";
export var changeList = "_40-0";
export var changePath = "_40-2";
export var diffArrow = "_40-5";
export var diffRow = "_40-3";
export var diffValue = "_40-4";
export var error = "_40-8";
export var notice = "_40-9";
export var result = "_40-6";
export var success = "_40-7";